import { useAppSelector } from '../../hooks/redux'
import { Colors } from '../../constants/Colors'
import style from './Sidebar.module.css'
import Header from './Header/Header'
import NavBar from './NavBar/NavBar'

const Sidebar = () => {
    
    const theme = useAppSelector<string>(state => state.theme.theme)

    return (
        <div
            className={style.container}
            style={{
                borderRight: `1px solid ${Colors[theme ?? 'light'].borderLight}`,
                backgroundColor: Colors[theme ?? 'light'].secondBackground
            }}
        >
            <Header />
            <NavBar />
        </div>
    )
}

export default Sidebar
